import {
  BugIcon,
  Building2Icon,
  HandPlatterIcon,
  MapPinIcon,
  RefreshCcwIcon,
  UserIcon,
  WrenchIcon,
} from 'lucide-react';

export const SETTING_SUB_PAGES = [
  {
    url: '/settings/office',
    label: 'Office',
    title: 'Office Information',
    description: 'Your office information and contact details.',
    icon: Building2Icon,
  },
  {
    url: '/settings/service-areas',
    label: 'Service Areas',
    title: 'Service Areas',
    description: 'Define the geographic regions where your business operates.',
    icon: MapPinIcon,
  },
  {
    url: '/settings/pests',
    label: 'Pests',
    title: 'Pests',
    description: 'Manage your pests.',
    icon: BugIcon,
  },
  {
    url: '/settings/skills',
    label: 'Skills',
    title: 'Skills',
    description: 'Manage skills available for your services.',
    icon: WrenchIcon,
  },
  {
    url: '/settings/employees',
    label: 'Employees',
    title: 'Employees',
    description: 'Manage your employees.',
    icon: UserIcon,
  },
  {
    url: '/settings/service_types',
    label: 'Service Types',
    title: 'Service Types',
    description: 'Manage your service types.',
    icon: HandPlatterIcon,
  },
  {
    url: '/settings/service_plans',
    label: 'Subscriptions',
    title: 'Subscriptions',
    description: 'Manage your subscriptions.',
    icon: RefreshCcwIcon,
  },
];
